export default __webpack_public_path__ + "static/media/oxygen.bc22b706.svg";